import type { Client } from '@/js/types/client.ts';
import { makeApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function getClient() {
  return makeRequest<Client>({
    method: 'GET',
    url: makeApiRoute('auth/client/get'),
  });
}
